export default __webpack_public_path__ + "static/media/banner.d3ee4116.png";